<div class="entry-content">

  <h1>
    Política de Privacidad – Rappi Chile SpA
  </h1>

  <p>Estas
    políticas de privacidad (las “Políticas de Privacidad”) regulan la forma en que
    Rappi Chile SpA, sociedad por acciones creada bajo las leyes de la República de
    Chile, representada en este acto por don Isaac Cañas, y con domicilio legal en
    Apoquindo 5950, Piso 5 comuna de Las Condes, Santiago, Chile, (“RAPPI”),
    tratará la información personal (la “Información Personal”) y los datos
    personales (la “Datos personales”) de los usuarios de la Plataforma,
    entendiendo por tales a los Consumidores, RappiRepartidores y/o visitantes de
    la Plataforma (el “Usuario” o los “Usuarios”).</p>



  <p>Estas
    Políticas de Privacidad describen, de forma detallada, la manera en que RAPPI
    recoge, utiliza, protege y comparte los Datos Personales y la Información
    Personal de sus Usuarios, de conformidad con la ley 19.628 sobre Protección de
    la vida Privada.</p>



  <p>RAPPI
    procurará que estas Políticas de Privacidad sean conocidas por todos quienes
    accedan y utilicen la Plataforma, garantizando su acceso.</p>



  <p>Las
    Políticas de Privacidad entrarán en vigor desde su aceptación por parte del
    Usuario y estarán vigentes hasta que éste revoque la autorización para su
    tratamiento. La revocación siempre deberá constar por escrito y no tendrá
    efecto retroactivo, sin perjuicio de que el Usuario pueda solicitar la eliminación
    total de sus datos.</p>



  <p>RAPPI
    podrá modificar estas Políticas de Privacidad en cualquier momento, de lo cual
    notificará a los Usuarios mediante el envío de e-mails, de mensajes de texto
    (SMS), whatsapp o cualquier otra aplicación de comunicaciones al teléfono
    celular, adjuntando la versión actualizada de las Políticas de Privacidad.
    Asimismo, informará de la actualización de las Políticas de Privacidad en la
    página principal u otras secciones de la Plataforma, a fin de mantener a los
    Usuarios siempre actualizados. Conforme a la ley aplicable, al usar la
    Plataforma tras haber recibido dicha notificación, se entiende que el Usuario
    acepta las actualizaciones de las Políticas de Privacidad.</p>



  <p>Los
    Usuarios siempre podrán decidir si aceptan o no las modificaciones a las
    Políticas de Privacidad. En el caso que el Usuario no acepte las nuevas
    Políticas de Privacidad, el vínculo entre este y RAPPI quedará disuelto y la
    Información Personal y Datos Personales de dicho Usuario no será usada de otra
    forma que la que correspondía de acuerdo a las Políticas de Privacidad
    debidamente aceptadas. Asimismo, en caso de que el Usuario lo solicite, dicha
    información podrá ser eliminada de manera permanente de los registros de Rappi.</p>



  <p>Lea
    detenidamente estas Políticas de Privacidad antes de acceder y/o utilizar a la
    Plataforma o de registrarse en ella.</p>



  <h3><strong>PRIMERO. Recopilación de
      los Datos Personales y de la Información Personal</strong></h3>



  <p>1.1&nbsp;&nbsp;
    Para utilizar la Plataforma, los Usuarios deben completar un registro (el
    “Registro”) con Datos Personales tales como nombre completo, número de cédula
    nacional de identidad o rol único tributario, dirección de correo electrónico,
    domicilio particular, número de teléfono y otros que le puedan ser solicitados
    y sean necesarios para el correcto uso de la Plataforma. Podría ocurrir que la
    plataforma no le solicite todos estos datos.</p>



  <p>1.2&nbsp;&nbsp;
    Asimismo, durante el uso de la Plataforma, los Usuarios proporcionarán a RAPPI
    información relativa a sus intereses, gustos, contactos, incluyendo la
    grabación de llamados que los Usuarios puedan realizar al servicio de soporte
    técnico de la Plataforma (la “Información Personal”).</p>



  <p>1.3&nbsp;&nbsp;
    Los Usuarios asumen el compromiso de indicar en el Registro sus Datos
    Personales de manera exacta, precisa y verdadera, así como también la
    obligación de actualizar sus Datos Personales cada vez que ocurra una
    modificación de los mismos.</p>



  <p>1.4&nbsp;&nbsp;
    Los Datos Personales introducidos por el Usuario en el Registro deberán ser
    exactos, actuales y veraces en todo momento. RAPPI se reserva el derecho a
    solicitar algún comprobante y/o dato adicional a efectos de corroborar los
    Datos Personales indicados en el Registro y de suspender, temporal y/o
    definitivamente, a aquel Usuario cuyos datos no hayan podido ser confirmados.
    No obstante lo anterior, RAPPI no se responsabiliza por la certeza de los Datos
    consignados en el Registro, toda vez que los mismos son suministrados por el
    Usuario y son de su única y exclusiva responsabilidad. En este sentido el
    Usuario garantiza y responde, en cualquier caso, de la veracidad, exactitud,
    vigencia y autenticidad de sus Datos Personales.</p>



  <p>1.5&nbsp;&nbsp;
    Los Datos Personales que el Usuario proporcione se integrarán en una base de
    datos personales de la que es responsable RAPPI. Asimismo, la Información
    Personal de los Usuarios será recopilada y utilizada en la forma descrita en
    estas Políticas de Privacidad.</p>



  <h3><strong>SEGUNDO. Cuenta Personal.</strong></h3>



  <p>2.1
    &nbsp; Una vez completado el Registro, RAPPI otorgará
    al Usuario una cuenta personal para acceder a la Plataforma con la contraseña
    que dicho Usuario elija (la “Cuenta”). El Usuario accederá a su Cuenta mediante
    el ingreso de su apodo de usuario y clave de seguridad personal elegida.</p>



  <p>2.2&nbsp;&nbsp;
    La Cuenta es personal, única e intransferible, y está expresamente prohibido
    que un mismo Usuario se registre más de una vez o posea más de una Cuenta como
    Consumidor o como RappiRepartidor. En caso de que RAPPI detecte o
    razonablemente considere que distintas Cuentas contienen datos coincidentes o
    relacionados, podrá cancelar, suspender o inhabilitar todas las Cuentas
    relacionadas sin que ello implique derecho a reclamo a alguno por parte de los
    Usuarios&nbsp; de dichas Cuentas, ya que
    podría ser considerado como un indicio de fraude.</p>



  <p>2.3&nbsp;&nbsp;
    El Usuario será el único responsable por el cuidado y buen uso de su Cuenta,
    así como de mantener su clave de acceso protegida. Si por cualquier razón un
    Usuario creyera que alguien puede conocer su clave de acceso, deberá
    modificarla ingresando a la opción de modificación dispuesta para tal fin en la
    Plataforma.</p>



  <p>2.4&nbsp;&nbsp;
    El Usuario que se registre en RAPPI y mantenga una Cuenta, consiente
    expresamente que RAPPI tenga acceso, en cualquier momento, a la totalidad de la
    información contenida en su Cuenta, incluyendo, en particular pero sin
    limitación alguna, a sus Datos Personales, e Información Personal sobre sus
    intereses, gustos, contactos y/o cualquier otro contenido alojado en su Cuenta
    y Registro.</p>



  <h3><strong>TERCERO. Uso de los Datos
      Personales y de la Información Personal</strong></h3>



  <p>3.1&nbsp;&nbsp;
    A través de la aceptación de las Políticas de Privacidad, el Usuario declara
    que:</p>



  <p>Autoriza
    a RAPPI a recopilar, procesar, utilizar y compartir sus Datos Personales, de
    acuerdo a estas Políticas de Privacidad y a la Ley Nº 19.628 de Protección de
    la Vida Privada.</p>



  <p>Autoriza
    a RAPPI a compilar y procesar sus Datos Personales e Información Personal con
    la finalidad de desarrollar estudios internos sobre los intereses,
    comportamientos y demografía de los Usuarios de la Plataforma.</p>



  <p>Autoriza
    a RAPPI a enviarle información o avisos a su e-mail, mensajes de texto (SMS),
    whastapp o cualquier otra aplicación de comunicaciones, a su teléfono celular
    sobre publicidad y/o promociones que puedan ser de interés para los Usuarios, o
    información sobre los servicios de RAPPI en general, que podrá incluir claves
    personales para el uso de la Plataforma, recordatorios de vencimientos de pagos
    y otras obligaciones adquiridas por el uso de la Plataforma.&nbsp;El Usuario
    siempre podrá solicitar que lo excluyan de las listas para el envío de
    información promocional y/o publicitaria, mediante un correo electrónico
    dirigido a servicioalclientechile&#64;rappi.com.</p>



  <p>Reconoce
    y acepta que RAPPI revele, comparta o transfiera, total o parcialmente, sus
    Datos Personales e Información Personal con su matriz, personas relacionadas o
    empresas afiliadas o relacionadas con RAPPI, a cualquier título y en el
    momento, forma y condiciones que estime pertinente. En estos casos, RAPPI
    velará porque se cumplan ciertos estándares, mediante la firma de acuerdos o
    convenios cuyo objeto sea la privacidad de tales Datos Personales y de la
    Información Personal.</p>



  <p>Autoriza
    expresamente a RAPPI para que almacene, guarde y procese sus Datos Personales o
    los transfiera o transmita a sus Socios Comerciales, de conformidad a la ley Nº
    19.628 y a la Política de Privacidad de Datos de Rappi.</p>



  <p>Reconoce
    que, en algunos casos, proveedores “outsourcing” de servicios podrán recoger
    información directamente del Usuario, por ejemplo si se realizan encuestas o
    estudios. En tales casos, el Usuario podrá recibir una notificación acerca de
    la participación de un proveedor de servicios en tales actividades y quedará, a
    su discreción, el acceder o no a proporcionarle sus Datos Personales u otra
    Información Personal que le sea solicitada, así como autorizar a dichos
    proveedores a utilizar o compartir esa información. En caso que el Usuario
    facilite, voluntariamente y por propia iniciativa, sus Datos Personales u otra
    información adicional a tales proveedores, estos últimos usarán esa información
    conforme a sus propias políticas de privacidad, de forma que el Usuario acepta
    y reconoce que RAPPI no se hace responsable por el uso indebido de sus Datos
    Personales y/u otra Información Personal que hagan los proveedores o compañías
    o sitios de Internet que actúen por cuenta propia. De conformidad a la ley, el
    proveedor que requiera recolectar datos personales de los Usuarios deberá
    siempre informar acerca del carácter facultativo de las respuestas y el
    propósito para el cual se está solicitando la información.</p>



  <p>Acepta
    que las llamadas que realice al servicio de soporte técnico de la Plataforma
    puedan ser grabadas con la finalidad de supervisar la prestación del Servicio
    por parte del RappiRepartidor; se puedan remitir sus consultas, sugerencias o
    reclamos a quienes corresponda; y, se investiguen a profundidad situaciones
    graves que puedan ser denunciadas.</p>



  <p>Autoriza
    a RAPPI para comunicar su Información Personal y Datos Personales con la
    finalidad de cumplir la normativa aplicable y cooperar con las autoridades
    judiciales y/o gubernamentales, en la medida en que RAPPI discrecionalmente lo
    entienda necesario y adecuado en relación con cualquier investigación de un
    ilícito o un fraude, infracción de derechos de propiedad industrial o
    intelectual, u otra actividad que sea ilegal o que pueda exponer a RAPPI o a
    los Usuarios a cualquier responsabilidad legal. Este derecho podrá ser ejercido
    por RAPPI a efectos de cooperar con el cumplimiento y ejecución de la ley,
    independientemente que no exista una orden judicial o administrativa al efecto.</p>



  <p>Reconoce
    que será el único responsable de todos los actos que tengan lugar mediante el
    uso de su Cuenta, lo que incluye hacerse cargo del pago de las tarifas que
    eventualmente se devenguen y de los perjuicios que puedan sufrir otros Usuarios
    y/o terceros por tal motivo.</p>



  <p>3.2&nbsp;&nbsp;
    RAPPI recopilará, utilizará y compatirá sus Datos Personales e Información
    Personal a fin de proporcionar seguridad a los Usuarios y que los Servicios
    sean prestados correctamente.</p>



  <p>De
    esta forma, RAPPI podrá utilizar la información recopilada para:</p>



  <ol>
    <li>Crear y actualizar la Cuenta del Usuario.</li>
    <li>Verificar la identidad del Usuario.</li>
    <li>Comprobar la veracidad de los Datos Personales de los Usuarios.</li>
    <li>Procesar y/o facilitar el pago de los Servicios (Precio, Tarifa y/o Propina).</li>
    <li>Permitir a los Consumidores hacer un seguimiento de su Solicitud y del recorrido del RappiRepartidor que le
      prestará el Servicio, permitiéndole tener acceso a su ubicación en tiempo real.</li>
    <li>Permitir al RappiRepartidor ubicar al Consumidor que haya efectuado la Solicitud que ha aceptado, a fin de que
      este pueda prestarle un Servicio eficiente y rápido, teniendo acceso a su ubicación en tiempo real.</li>
    <li>Permitir que el RappiRepartidor y el Consumidor puedan comunicarse entre sí ante cualquier eventualidad que
      surja durante la prestación del Servicio.</li>
    <li>Permitir que el servicio de soporte técnico de la Plataforma pueda contactar a RappiRepartidores y/o
      Consumidores a fin de que el Servicio sea llevado a cabo de la forma más eficiente y rápida posible.</li>
    <li>Realizar pruebas, investigaciones y análisis respecto a la prestación de los Servicios y de los productos
      adquiridos por los Consumidores.</li>
    <li>Enviar a los Usuarios información respecto a promociones y/o publicidad de sus Servicios y de productos de sus
      Comercios Aliados.</li>
    <li>En el caso de la Aplicación “Soy Rappi”, para que sus usuarios puedan aceptar y tramitar las órdenes más
      cercanas a su ubicación, la Aplicación “Soy Rappi” recogerá datos de su localización, aún cuando la Aplicación se
      encuentre cerrada o no esté en uso.</li>
    <li>El app ‘Soy Rappi’ recoge y almacena el número telefónico del usuario el cual es almacenado en nuestra base de
      datos usando métodos de encriptación para garantizar la protección de la información personal del usuario. La data
      recolectada se utiliza para identificar posibles comportamientos atípicos dentro de la aplicación y no es
      compartida ni transferida a terceros.</li>
  </ol>



  <h3><strong>CUARTO. Seguridad y
      Almacenamiento de los Datos Personales</strong></h3>



  <p>4.1&nbsp;&nbsp;
    RAPPI tratará los Datos Personales de sus Usuarios de conformidad a lo
    dispuesto en la Ley Nº 19.628 sobre Protección de la Vida Privada y respetando
    siempre el pleno ejercicio de los derechos fundamentales de los Usuarios.</p>



  <p>4.2&nbsp;&nbsp;
    RAPPI considera que los Datos Personales y otra Información Personal de sus
    Usuarios como un activo que debe ser protegido de cualquier pérdida o acceso no
    autorizado, por lo que tomará todas las precauciones para resguardarla mediante
    la implementación de mecanismos de seguridad informática eficaces, tales como
    cortafuegos (“firewalls”) y Secure Socket Layers (“SSL”). RAPPI se obliga a
    cumplir con toda la normativa aplicable en materia de medidas de seguridad
    aplicables a los Datos Personales, utilizando los estándares de la industria
    entre materia de protección y confidencialidad de su Información Personal.</p>



  <p>4.3&nbsp;&nbsp;
    No obstante, y considerando que internet es un sistema abierto, de acceso
    público, RAPPI no puede garantizar que terceros no autorizados no puedan eventualmente
    superar las medidas de seguridad y utilizar la Información Personal y/o Datos
    Personales del Usuario en forma indebida.</p>



  <p>4.4&nbsp;&nbsp;
    El Usuario reconoce y acepta expresamente que RAPPI, a su exclusivo criterio,
    recabe, almacene y eventualmente monitoree el intercambio de mensajes y correos
    electrónicos entre los Usuarios y que sean efectuados dentro de la Plataforma,
    con el objetivo de contribuir a la seguridad de las relaciones y comunicaciones
    que se desarrollan a través de la Plataforma.</p>



  <p>4.5&nbsp;&nbsp;
    RAPPI no se hace responsable por interceptaciones ilegales o violación de sus
    sistemas o bases de datos por parte de personas no autorizadas. RAPPI, tampoco
    se hace responsable por la indebida utilización de la información obtenida por
    esos medios.</p>



  <p>4.6&nbsp;&nbsp;
    Todos los Datos Personales serán almacenados en un archivo o soporte
    automatizado de datos personales.</p>



  <p>4.7&nbsp;&nbsp;
    RAPPI no venderá, arrendará ni compartirá los Datos Personales u otra
    Información Personal de sus Usuarios, excepto en las formas establecidas en
    estas Políticas de Privacidad.</p>



  <p>4.8&nbsp;&nbsp;
    RAPPI conservará los Datos Personales y la Información Personal de los Usuarios
    por un periodo de diez (10) años, a fin de resguardarse y poder resolver
    posibles disputas o reclamos, detectar problemas o incidencias y solucionarlos,
    y dar cumplimiento a lo dispuesto en los Términos y Condiciones.<br>
    <br>
  </p>



  <h3><strong>QUINTO. Derecho de
      Acceso, Modificación, Rectificación y Eliminación de los Datos Personales.</strong></h3>



  <p>5.1&nbsp;&nbsp;
    Los Usuarios podrán ejercitar los derechos de acceder, modificar, rectificar y
    eliminar sus Datos Personales, incluyendo su dirección de e-mail, así como a
    oponerse al tratamiento de los mismos y a ser informado de las cesiones y/o
    transferencias internacionales de sus Datos Personales, de conformidad a lo
    dispuesto en la Ley Nº 19.628 sobre Protección de la Vida Privada.</p>



  <p>5.2&nbsp;&nbsp;
    Conforme se establece en el artículo 12 de la Ley Nº 19.628, el Usuario titular
    de los Datos Personales y previa acreditación de su identidad, tiene la
    facultad de ejercer el derecho de acceder, modificar, rectificar y/o eliminar
    sus Datos Personales, en forma gratuita, solicitud que deberá ser atendida
    dentro de los 2 (dos) días hábiles a que se efectuado.</p>



  <p>5.3&nbsp;&nbsp;
    La solicitud de acceso, modificación, rectificación y/o eliminación de Datos
    Personales deberá efectuarse mediante correo electrónico enviado a
    servicioalclientechile&#64;rappi.com, incluyendo su nombre completo, cédula
    nacional de identidad o rol único tributario, y número de teléfono celular. Sin
    perjuicio de los cambios que se realicen, RAPPI podrá conservar la información
    personal anterior por motivos de seguridad y control del fraude, en caso de
    tener dudas razonables.</p>



  <p>5.4&nbsp;&nbsp;
    En caso de infracción a las disposiciones anteriores, los Usuarios podrán
    recurrir ante el juez de letras en lo civil de Santiago, solicitando amparo a
    los derechos consagrados en la Ley Nº 19.628.</p>



  <h3><strong>SEXTO. Menores de Edad</strong></h3>



  <p>6.1&nbsp;Existen
    ciertos servicios en la Plataforma, los cuales solo pueden ser solicitados por
    mayores de 18 años.</p>



  <p>6.2&nbsp;&nbsp;
    RAPPI se reserva el derecho de verificar, por los medios que considere más
    oportunos, la edad real de cualquier Usuario.</p>



  <p>6.3&nbsp;&nbsp;
    Bajo sospecha o constatación de que un Usuario sea menor de 18 años y de que ha
    falseado los datos que se requieren para adquirir productos o servicios que
    requieran de mayoría de edad, RAPPI podrá denegar dicho servicio o producto,
    sin derecho a reclamo alguno por parte del Usuario afectado.</p>



  <h3><strong>SÉPTIMO. Requerimientos
      Legales</strong></h3>



  <p>7.1&nbsp;&nbsp;
    RAPPI cooperará con las autoridades competentes y con otros terceros para
    garantizar el cumplimiento de la normativa vigente, por ejemplo en materia de
    protección de derechos de propiedad industrial e intelectual, prevención del
    fraude, entre otras.</p>



  <p>7.2&nbsp;&nbsp;
    En este sentido, RAPPI podrá revelar la Información Personal y Datos Personales
    de sus Usuarios en caso que así sea requerido por autoridades judiciales o
    gubernamentales competentes, para efectos de investigaciones conducidas por
    ellas, aunque no exista una orden ni una citación ejecutiva o judicial, así como
    también en caso de investigaciones de carácter penal, fraude o relacionadas con
    piratería informática o la violación de derechos de autor. En tales
    situaciones, RAPPI colaborará con las autoridades competentes con el fin de
    salvaguardar la integridad y la seguridad de la comunidad y la de sus Usuarios.</p>



  <p>7.3&nbsp;&nbsp;
    Para tales efectos, RAPPI podrá comunicar cualquier Información Personal y/o
    Datos Personales de sus Usuarios, con la finalidad de cumplir la normativa
    aplicable y cooperar con las autoridades competentes, en la medida en que
    discrecionalmente lo entienda necesario y adecuado en relación con cualquier
    investigación de un ilícito o un fraude, infracción de derechos de propiedad
    industrial o intelectual, u otra actividad que sea ilegal o que pueda exponer a
    RAPPI o a los Usuarios a cualquier responsabilidad legal.&nbsp; Este derecho
    será ejercido por RAPPI a efectos de cooperar con el cumplimiento y ejecución
    de la ley, independientemente que no exista una orden judicial o administrativa
    al efecto.</p>



  <p>7.4&nbsp;&nbsp;
    Adicionalmente,&nbsp;RAPPI se reserva el derecho (y los Usuarios lo autorizan
    expresamente a ello) de comunicar información a entidades o terceros cuando
    haya motivos suficientes para considerar que la actividad de un Usuario sea
    sospechosa de intentar o cometer un delito o intentar perjudicar a otras
    personas.&nbsp;Este derecho será utilizado por RAPPI a su entera discreción,
    cuando lo considere apropiado o necesario para mantener la integridad y la
    seguridad de la comunidad y la de sus Usuarios; para hacer cumplir los Términos
    y Condiciones y las Políticas de Privacidad de su Plataforma; y, a efectos de
    cooperar con la ejecución y cumplimiento de la ley. Este derecho será ejercido
    por RAPPI a efectos de cooperar con el cumplimiento y ejecución de la ley,
    independientemente que no exista una orden judicial o administrativa al efecto.</p>



  <h3><strong>OCTAVO. Cambio en las
      preferencias de e-mails, SMS u otros medios de comunicación</strong></h3>



  <p>8.1&nbsp;&nbsp;
    Sin perjuicio que RAPPI quiere mantener a los Usuarios actualizados en todo
    momento sobre promociones, novedades, productos en oferta, etc., los Usuarios
    siempre podrán seleccionar los e-mails, SMS, otros medios de comunicación e
    información promocional que quieren recibir de RAPPI.</p>



  <p>8.2&nbsp;&nbsp;
    En caso que el Usuario no quiera recibir dichas comunicaciones, podrá
    solicitarlo cambiando sus preferencias en el email siguiendo las instrucciones
    que RAPPI proporciona en sus comunicaciones o bien a través de su Cuenta,
    seleccionando aquella información que efectivamente quiere recibir.</p>
</div>